<template>
    <div>
        <div v-if="props.question.text != null" class="row col mb-2">{{ props.question.text[participant.language] }}</div>
        <div class="row">
            <div class="col-4">
                <input 
                    class="form-control" 
                    type="date"
                    :name="props.question.variable"
                    v-model="response[props.question.variable]"
                    @input="saveResponse"
                >
            </div>
            <div class="col-8">
                <label
                    class="col-form-label"
                    :for="props.question.variable"
                >
                    {{ props.question.label[participant.language] }}
                </label>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'
    import debounce from "lodash/debounce"

    const { saveResponse } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])
</script>